import type { GameDescriptor } from '@everyturn/engine/runtime';

export const sortableTestDescriptor = {
  gameId: 'sortable-test',
  displayName: 'Sortable Test',
  seats: ['south'],
  minPlayers: 1,
  maxPlayers: 1,
  defaultSeat: 'south',
  layoutId: 'sortable-test',
} as const satisfies GameDescriptor;
